import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const BenefitsSection: React.FC = () => {
  const benefits = [
    'No more phone calls or waiting on hold',
    '24/7 online booking availability',
    'Instant confirmation and reminders',
    'Easy rescheduling and cancellations',
    'Secure payment processing',
    'Customer reviews and ratings',
  ];

  return (
    <section className="py-10 sm:py-16 px-3 xs:px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl xs:text-3xl sm:text-4xl font-bold text-gray-900 mb-2 sm:mb-4">
            Everything You Need
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            All the features to make booking effortless
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6">
          {benefits.map((benefit) => (
            <div key={benefit} className="flex items-start space-x-2 sm:space-x-3 p-3 sm:p-4">
              <CheckCircleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-green-500 flex-shrink-0 mt-0.5" />
              <p className="text-sm sm:text-lg text-gray-700">{benefit}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
